import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
const KIT_BENEFITS = ['Manual y guiones de sesión', 'Genograma familiar', '350 preguntas terapéuticas', 'Fichas y seguimiento', 'Tarjetas y dinámicas', 'Acceso inmediato y de por vida'];
export function DiferencialHibrido() {
  const prefersReducedMotion = useReducedMotion();
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full overflow-hidden bg-white py-16 md:py-24" data-id="element-128" data-mp="1lc99smu7ychc">
      <div className="mx-auto max-w-3xl px-4" data-id="element-129" data-mp="1pca1h96bwk6c">
        <motion.header initial={prefersReducedMotion ? undefined : {
        opacity: 0,
        y: 16
      }} whileInView={prefersReducedMotion ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.35,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-2xl text-center" data-id="element-130" data-mp="1pbi53w4wqif0">
          <p className="text-[10px] font-black uppercase tracking-[0.22em] text-[#a8894f] md:text-xs" data-id="element-131" data-mp="21ias4ah3zikm">
            La solución que estabas buscando
          </p>
          <h2 className="mt-3 font-['Playfair_Display',_serif] text-3xl font-bold leading-tight text-[#2e1065] md:text-5xl" data-id="element-132" data-mp="1rtj6ek2n5ui5">
            Todo lo que necesitás para preparar sesiones con{' '}
            <strong className="font-extrabold text-[#5b1fa1]" data-id="element-133" data-mp="1hvms5jeeqjft">más seguridad.</strong>
          </h2>
          <p className="mx-auto mt-4 max-w-[42ch] text-sm leading-relaxed text-[#665873] md:text-base" data-id="element-134" data-mp="1du1dptm85x3i">
            Conocé el Kit de Constelación Familiar Terapéutica: un sistema
            profesional con guiones, genogramas, preguntas, fichas y herramientas
            prácticas para organizar y acompañar tus sesiones.
          </p>
        </motion.header>

        <motion.div initial={prefersReducedMotion ? undefined : {
        opacity: 0,
        y: 16
      }} whileInView={prefersReducedMotion ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.45,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-7 -mx-4 md:mx-0" data-id="element-135" data-mp="3386gd1fbjwyl">
          <motion.div animate={prefersReducedMotion ? undefined : {
          y: [0, -5, 0]
        }} transition={{
          duration: 5.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-136" data-mp="mmrkd4xcs9jt">
            <img src="https://cdn.magicpatterns.com/uploads/dPdHriE3fFCsuizfgpQgUk/Kit_terapeutico_Constelacion_Familiar.webp" alt="Kit de Constelación Familiar Terapéutica con libro profesional, genograma, fichas de sesión, tarjetas, preguntas y guías impresas" className="block h-auto w-full drop-shadow-[0_16px_22px_rgba(46,16,101,0.16)]" data-id="element-137" data-mp="1k9rpuz5xpx6e" />
          </motion.div>
        </motion.div>

        <motion.ul initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} variants={prefersReducedMotion ? undefined : {
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.05
          }
        }
      }} className="mt-7 grid grid-cols-2 gap-x-4 gap-y-3 rounded-2xl border border-[#e8decf] bg-[#fffdf8] p-4 text-left" data-id="element-138" data-mp="2d4ps7fdnldn4">
          {KIT_BENEFITS.map(benefit => <motion.li key={benefit} variants={prefersReducedMotion ? undefined : {
          hidden: {
            opacity: 0,
            y: 10
          },
          visible: {
            opacity: 1,
            y: 0
          }
        }} transition={{
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-2 text-[11px] leading-snug text-[#574a63] md:text-sm" data-id="element-139" data-mp="1pg6lv5e5zaxo">
              <CheckIcon size={15} strokeWidth={3} className="mt-0.5 shrink-0 text-[#b78b31]" aria-hidden="true" data-id="element-140" data-mp="1jemudr9me0c2" />
              <strong className="font-bold" data-id="element-141" data-mp="1tbrgxs7dnxte">{benefit}</strong>
            </motion.li>)}
        </motion.ul>

        <motion.p initial={prefersReducedMotion ? undefined : {
        opacity: 0,
        y: 12
      }} whileInView={prefersReducedMotion ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-7 max-w-[37ch] text-center font-['Playfair_Display',_serif] text-lg leading-snug text-[#51405f] md:text-xl" data-id="element-142" data-mp="1y3sy9sjekeqa">
          Un sistema{' '}
          <strong className="font-bold text-[#2e1065]" data-id="element-143" data-mp="horje20f7ig1">
            completo, organizado y listo
          </strong>{' '}
          para acompañarte en cada sesión.
        </motion.p>

        <div className="mt-7 text-center" data-id="element-144" data-mp="f4373zbvdnb7">
          <button onClick={scrollToPurchase} className="group relative w-full overflow-hidden rounded-full bg-[#2e1065] px-6 py-5 text-white shadow-[0_18px_34px_-14px_rgba(46,16,101,0.65)] transition-colors duration-200 ease-out hover:bg-[#3d187f] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2e1065] md:w-auto md:min-w-[360px]" data-id="element-145" data-mp="f54tgzyc5w88">
            <motion.span aria-hidden="true" animate={prefersReducedMotion ? undefined : {
            x: ['-160%', '220%']
          }} transition={{
            duration: 1.1,
            delay: 3.5,
            repeat: Infinity,
            repeatDelay: 4,
            ease: 'linear'
          }} className="absolute inset-y-0 w-1/3 -skew-x-12 bg-white/20" data-id="element-146" data-mp="y2634y2u4kii" />
            <span className="relative z-10 flex items-center justify-center gap-2.5 text-[13px] font-black uppercase tracking-[0.14em] md:text-[15px]" data-id="element-147" data-mp="33vvyl4azajqr">
              Quiero mi sistema completo
              <ArrowRightIcon size={17} strokeWidth={2.5} aria-hidden="true" data-id="element-148" data-mp="1vum3waqy2xsz" />
            </span>
          </button>
          <p className="mt-3 text-xs font-medium text-[#776a7f]" data-id="element-149" data-mp="1lyj4vdre3fa9">
            Descarga inmediata · 100% digital · Acceso de por vida
          </p>
        </div>
      </div>
    </section>;
}